import { Pipe, PipeTransform } from '@angular/core';
import { ProjectChecklist } from '@portal-core/project-checklists/models/project-checklist.model';

@Pipe({
  name: 'mcProjectChecklistColorClass'
})
export class ProjectChecklistColorClassPipe implements PipeTransform {
  transform(checklist: ProjectChecklist | null | undefined, style: 'bg' | 'border' | 'fill' | 'text' | 'tooltip', luminosity: '' | 'muted' | 'vivid' = ''): string {
    const completedPercentage: number = checklist?.Analytics?.CompletedPercent;

    if (completedPercentage >= 100) {
      return this.getStyleClass('checklist-completed', luminosity, style);
    } else if (completedPercentage < 100 && completedPercentage > 0) {
      return this.getStyleClass('checklist-in-progress', luminosity, style);
    } else if (completedPercentage === -1) {
      return this.getStyleClass('checklist-not-started', luminosity, style);
    } else {
      return this.getStyleClass('checklist-todo', luminosity, style);
    }
  }

  getStyleClass(className: string, luminosity: '' | 'muted' | 'vivid', style: 'bg' | 'border' | 'fill' | 'text' | 'tooltip'): string {
    if (style === 'tooltip') {
      return `mc-${className}${luminosity ? '-' + luminosity : ''}`;
    } else {
      return `mc-${style}-${className}${luminosity ? '-' + luminosity : ''}`;
    }
  }
}
